export var HELPDESK_URL = 'https://purecars.zendesk.com';
export var AUDIENCES_ARTICLE_URL = "".concat(HELPDESK_URL, "/hc/en-us/articles/360021837512");
export var OFFERS_ARTICLE_URL = "".concat(HELPDESK_URL, "/hc/en-us/articles/360021443532");